import React, { Component, useContext, useState } from 'react';
import LegoAdminPageContext from '../../pages/legoAdminPageContext';

import ModalBatchEditDoc, { defaultColumns, LOGIC_SET_UNSET__FIELD } from './ModalBatchEditDoc';


export default function ModalBatchEditLegos({ docs, onCancel, onSave  }) {
  let { page } = useContext(LegoAdminPageContext);
  const svc = page.service('services/legos');

  let columns = [
    defaultColumns.legoState,
    defaultColumns.locales,
    defaultColumns.context,
    defaultColumns.labels
  ];

  return <ModalBatchEditDoc docs={docs} onCancel={onCancel} onSave={onSave} service={svc} columns={columns}/>;
};
